import { Box, Button, Tabs } from "@mantine/core"
import { DownloadSimpleIcon } from "@phosphor-icons/react"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { OrderApi } from "../../apis"
import { BackOrderList } from "../../components/back-order/list"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { ReasonTooltip } from "../../components/ui"
import { IOrderPlus } from "../../models/Order"
import HttpHandler from "../../utils/http-handler"
import { message } from "../../utils/message"
import { SupplierPurchaseList, SupplierPurchaseListRef } from "./list"

export function SupplierPurchaseTabs() {
  const { t } = useTranslation(["supplierSales", "common"])
  const [activeTab, setActiveTab] = useState<string>("APPROVED")
  const [checked, setChecked] = useState<IOrderPlus[]>([])
  const [excelBusy, setExcelBusy] = useState(false)
  const listRef = useRef<SupplierPurchaseListRef>(null)

  const ORD_PO_LIST = usePermission("ORD_PO_LIST")
  const ORD_BCK_ORD = usePermission("ORD_BCK_ORD")

  const isList = activeTab === "APPROVED"

  const downloadExcel = async () => {
    setExcelBusy(true)
    try {
      const { url } = await OrderApi.excel({ filter: listRef.current?.getFilters(), order: listRef.current?.getOrder() })
      window.open(url, "_blank")
    } catch (err) {
      message.error((err as HttpHandler)?.message!)
    } finally {
      setExcelBusy(false)
    }
  }

  return (
    <PageLayout
      title={t("supplierSales:purchase.title")}
      subTitle={t("supplierSales:purchase.subtitle")}
      breadcrumb={[{ to: "/", label: t("common:breadcrumb.home") }, { label: t("supplierSales:purchase.breadcrumb") }]}
      extra={
        isList
          ? [
              <ReasonTooltip key="excel" reason={ORD_PO_LIST.reason}>
                <Button variant="default" leftSection={<DownloadSimpleIcon size={16} />} loading={excelBusy} onClick={downloadExcel}>
                  {t("supplierSales:purchase.excelDownload")}
                </Button>
              </ReasonTooltip>,
            ]
          : []
      }
    >
      <Tabs value={activeTab} onChange={(e) => setActiveTab(e as string)} keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="APPROVED">{t("supplierSales:purchase.tabReceived")}</Tabs.Tab>
          <Tabs.Tab value="PACKAGE">{t("supplierSales:purchase.tabPackaged")}</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="APPROVED">
          {ORD_PO_LIST.hasAccess ? (
            <SupplierPurchaseList ref={listRef} checked={checked} setChecked={setChecked} />
          ) : (
            <Box>{ORD_PO_LIST.accessDenied()}</Box>
          )}
        </Tabs.Panel>
        <Tabs.Panel value="PACKAGE" mt="md">
          {ORD_BCK_ORD.hasAccess ? <BackOrderList /> : ORD_BCK_ORD.accessDenied()}
        </Tabs.Panel>
      </Tabs>
    </PageLayout>
  )
}
